import { ButtonHTMLAttributes } from 'react';
import {
  Button as StyledButton,
  CalendarIcon,
  Value,
  Separator,
} from './Button.styles';
import { useFormattedDate } from './useFormattedDate';

type DatePickerButtonProps = {
  title: string;
  from?: Date;
  to?: Date;
  size?: 'small' | 'default';
  dateDisplay?: 'short' | 'default';
  invalid?: boolean;
} & Pick<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-invalid' | 'aria-errormessage' | 'onClick' | 'className'
>;

const Button = ({
  title,
  from,
  to,
  size = 'default',
  dateDisplay = 'default',
  invalid,
  ...rest
}: DatePickerButtonProps) => {
  const { localDate: fromDate, isoDate: isoFromDate } = useFormattedDate(
    from,
    dateDisplay,
  );
  const { localDate: toDate, isoDate: isoToDate } = useFormattedDate(
    to,
    dateDisplay,
  );

  return (
    <StyledButton
      type="button"
      id="datepicker"
      aria-haspopup="true"
      title={title}
      $size={size}
      $invalid={invalid}
      {...rest}
    >
      {size === 'default' && <CalendarIcon id="datepicker-cal-icon" />}
      {fromDate && toDate && (
        <Value
          id="datepickerValue"
          data-from={isoFromDate}
          data-to={isoToDate}
          $dateDisplay={dateDisplay}
        >
          <time>{fromDate}</time>
          <Separator $dateDisplay={dateDisplay}> – </Separator>
          <time>{toDate}</time>
        </Value>
      )}
    </StyledButton>
  );
};

export { Button };
